import ScribeImageElementModel from 'js/models/ScribeImageElementModel';

export const getImageStyleProperties = (element: ScribeImageElementModel) => ({
  opacity: element.opacity
});
